/*!
 * AFA sale badge  -  afa-sale-badge.js
 * Shows a sale-price badge over the main product image on product pages,
 * and swaps it when the shopper changes variants.
 *
 * TO ADD OR CHANGE A BADGE
 *   1. Upload sale-badge-<code>.png to Content > Files (code = sale price, no
 *      symbols: $23.97 -> 2397, $1,559.97 -> 155997, $15.00 -> 1500).
 *   2. Add or edit a line in BADGES below:  'variant ID': 'code',
 *   Variants not listed get no badge. Delete a line to remove a badge.
 *
 * Variant IDs: Products > [product] > click the variant; the ID is the last
 * number in the admin URL.
 */
(function () {
  'use strict';

  // ======================= SETTINGS =======================

  var IMAGE_BASE = 'https://cdn.shopify.com/s/files/1/0935/3671/5061/files/';

  // Styles live in custom.css (.afa-sale-badge and .product-image-container).

  // ============ LOOKUP: variant ID -> badge code ============

  var BADGES = {
    // All-Fit Lip Kit - Colors
    '50777401000245': '29997',  // WHITE30TL  $299.97
    '50777401033013': '8997',   // TRDLIPKIT-WHITE09  $89.97
    '50777401065781': '13797',  // WHITE14TL  $137.97
    '50777401098549': '22797',  // 23TLWHITE  $227.97
    '50777401131317': '29997',  // DARKGRAY30TL  $299.97
    '50777401164085': '8997',   // TRDLIPKIT-DARKGRAY09  $89.97
    '50777401196853': '13797',  // DARKGRAY14TL  $137.97
    '50777401229621': '22797',  // 23TLDarkGray  $227.97
    '50777401262389': '29997',  // SILVER30TL  $299.97
    '50777401295157': '8997',   // TRDLIPKIT-LIGHTGRAY09  $89.97
    '50777401327925': '13797',  // SILVER14TL  $137.97
    '50777401360693': '22797',  // 23TLSILVER  $227.97
    '50777401393461': '29997',  // RED30TL  $299.97
    '50777401426229': '8997',   // TRDLIPKIT-RED09  $89.97
    '50777401458997': '13797',  // RED14TL  $137.97
    '50777401491765': '22797',  // 23TLRED  $227.97
    '50777401524533': '29997',  // PINK30TL  $299.97
    '50777401557301': '8997',   // TRDLIPKIT-PINK09  $89.97
    '50777401590069': '13797',  // PINK14TL  $137.97
    '50777401622837': '22797',  // 23TLPINK  $227.97
    '50777401786677': '39597',  // DARKGRAY30ML  $395.97
    '50777401819445': '11997',  // DARKGRAY09ML  $119.97
    '50777401852213': '18597',  // DARKGRAY14ML  $185.97
    '50777401884981': '30597',  // MID23DARKGRAY  $305.97
    '50777402048821': '39597',  // RED30ML  $395.97
    '50777402081589': '11997',  // RED09ML  $119.97
    '50777402114357': '18597',  // RED14ML  $185.97
    '50777402147125': '30597',  // MID23RED  $305.97
    '50777402179893': '39597',  // PINK30ML  $395.97
    '50777402212661': '11997',  // PINK09ML  $119.97
    '50777402245429': '18597',  // PINK14ML  $185.97
    '50777402278197': '30597',  // MID23PINK  $305.97

    // All-Fit Rim Trim
    '50815656526133': '7797',   // RIMT25RED  $77.97
    '50815656427829': '7797',   // RIMT25BLACK  $77.97
    '50815656460597': '7797',   // RIMT25WHITE  $77.97
    '50815656493365': '7797',   // RIMT25SILVER  $77.97
    '50815656558901': '7797',   // RIMT25ORANGE  $77.97
    '50815656591669': '7797',   // RIMT25YELLOW  $77.97
    '50815656624437': '7797',   // RIMT25BLUE  $77.97
    '50815656657205': '7797',   // RIMT25PINK  $77.97
    '50815656689973': '7797',   // RIMT25PURPLE  $77.97
    '50815822823733': '8397',   // RIMT25CHROME  $83.97
    '50815822856501': '8397',   // RIMT25CFIBER  $83.97

    // All-Fit Edge Trim
    '50815970804021': '2397',   // EDGET10BLACK  $23.97
    '50815970640181': '2397',   // EDGET10CHROME  $23.97
    '50815970672949': '2397',   // EDGET10WHITE  $23.97
    '50815970705717': '2397',   // EDGET10RED  $23.97
    '50815970738485': '2397',   // EDGET10CLEAR  $23.97
    '50815970771253': '2397',   // EDGET10DARKRED  $23.97
    '50815970836789': '2397',   // EDGET10CFIBER  $23.97
    '50815970869557': '2397',   // EDGET10GOLD  $23.97
    '50815970902325': '2397',   // EDGET10BLUE  $23.97
    '50815970935093': '2397',   // EDGET10ORANGE  $23.97
    '50815970967861': '2397',   // EDGET10YELLOW  $23.97
    '50815971000629': '2397',   // EDGET10SILVER  $23.97
    '52778785636661': '2397',   // EDGET10PINK  $23.97

    // All-Fit Gap Trim
    '50816050856245': '2397',   // GAPT10CFIBER  $23.97
    '50816050921781': '2397',   // GAPT10RED  $23.97
    '50816050889013': '2397',   // GAPT10CHROME  $23.97
    '50816050954549': '2397',   // GAPT10WHITE  $23.97
    '50816050987317': '2397',   // GAPT10SILVER  $23.97
    '50816051020085': '2397',   // GAPT10YELLOW  $23.97
    '50816051052853': '2397',   // GAPT10BLUE  $23.97
    '50816051085621': '2397',   // GAPT10ORANGE  $23.97
    '52778807951669': '2397',   // GAPT10PINK  $23.97

    // All-Fit Lip Trim
    '50816081822005': '2997',   // LIPT10RED  $29.97
    '50816087753013': '4197',   // LIPT14RED  $41.97
    '50816087785781': '8997',   // LIPT30RED  $89.97
    '50816081854773': '2997',   // LIPT10YELLOW  $29.97
    '50816087818549': '4197',   // LIPT14YELLOW  $41.97
    '50816087851317': '8997',   // LIPT30YELLOW  $89.97
    '50816081887541': '2997',   // LIPT10ORANGE  $29.97
    '50816087884085': '4197',   // LIPT14ORANGE  $41.97
    '50816087916853': '8997',   // LIPT30ORANGE  $89.97
    '50816081920309': '2997',   // LIPT10BLUE  $29.97
    '50816087949621': '4197',   // LIPT14BLUE  $41.97
    '50816087982389': '8997',   // LIPT30BLUE  $89.97
    '50816081953077': '2997',   // LIPT10GOLD  $29.97
    '50816088015157': '4197',   // LIPT14GOLD  $41.97
    '50816088047925': '8997',   // LIPT30GOLD  $89.97
    '50816081985845': '2997',   // LIPT10CHROME  $29.97
    '50816088080693': '4197',   // LIPT14CHROME  $41.97
    '50816088113461': '8997',   // LIPT30CHROME  $89.97
    '50816082018613': '2997',   // LIPT10WHITE  $29.97
    '50816088146229': '4197',   // LIPT14WHITE  $41.97
    '50816088178997': '8997',   // LIPT30WHITE  $89.97
    '50816082051381': '2997',   // LIPT10CFIBER  $29.97
    '50816088211765': '4197',   // LIPT14CFIBER  $41.97
    '50816088244533': '8997',   // LIPT30CFIBER  $89.97

    // All-Fit Dual Flex Trim
    '50816266699061': '3597',   // DUALFT10RED  $35.97
    '50816266731829': '3597',   // DUALFT10CHROME  $35.97
    '50816266764597': '3597',   // DUALFT10DARKRED  $35.97
    '50816266797365': '3597',   // DUALFT10CFIBER  $35.97

    // All-Fit Bumper Quick Release
    '50815799460149': '3297',   // QRSILVER-1RB  $32.97
    '50815799492917': '4077',   // QRSILVER-2RB  $40.77
    '50815799525685': '2397',   // QRSILVER-0RB  $23.97
    '50815799558453': '3297',   // QRBLACK-1RB  $32.97
    '50815799591221': '4077',   // QRBLACK-2RB  $40.77
    '50815799623989': '2397',   // QRBLACK-0RB  $23.97
    '50815799656757': '3297',   // QRRED-1RB  $32.97
    '50815799689525': '4077',   // QRRED-2RB  $40.77
    '50815799722293': '2397',   // QRRED-0RB  $23.97
    '50815799755061': '3297',   // QRGOLD-1RB  $32.97
    '50815799787829': '4077',   // QRGOLD-2RB  $40.77
    '50815799820597': '2397',   // QRGOLD-0RB  $23.97
    '50815799853365': '3297',   // QRNEOCHROME-1RB  $32.97
    '50815799886133': '4077',   // QRNEOCHROME-2RB  $40.77
    '50815799918901': '2397',   // QRNEOCHROME-0RB  $23.97

    // All-Fit Bumper Scrape Guard
    '50815729008949': '8397',   // ScrapeGuard10  $83.97

    // All-Fit Replacement Square Body Side Molding – 1973-1987 Chevy/GMC
    '52238549319989': '14997',  // GMCSB7387BLACKCH26.2.25  $149.97
    '52238549287221': '14997',  // GMC2SBCHROME26  $149.97

    // PROTECTiQ PRO - Single Pack
    '50820258070837': '7797',   // PROiQBLACK-FBA  $77.97
    '50820258103605': '7797',   // PROiQRED-FBA  $77.97
    '50820258136373': '7797',   // PROiQYELLOW-FBA  $77.97
    '50820258169141': '7797',   // PROiQBLUE-FBA  $77.97
    '50820258201909': '7797',   // PROiQWHITE-FBA  $77.97
    '50820258234677': '7797',   // PROiQSILVER-FBA  $77.97

    // PROTECTiQ PRO - Vibrant 3 Color Set
    '50820293001525': '20997',  // PROiQBlack  $209.97

    // PROTECTiQ PRO 100 Count Mixed Colors
    '50820313645365': '506997', // 100PIQPSEMA  $5069.97

    // INFLATiQ® by RIMiQ® Portable Tire Inflator - Powerful, Award-Winning QwikFlow® Technology
    '51999178162485': '7797',   // INFLATiQ  $77.97
    '52078004207925': '15597',  // INFLATiQ-2  $155.97
    '52078004240693': '23397',  // INFLATiQ-3  $233.97
    '52078004273461': '31197',  // INFLATiQ-4  $311.97
    '51999184552245': '8997',   // PINKINFLATiQ  $89.97
    '52078004306229': '17997',  // PINKINFLATiQ-2  $179.97
    '52078004338997': '26997',  // PINKINFLATiQ-3  $269.97
    '52078004371765': '35997',  // PINKINFLATiQ-4  $359.97
    '51999185469749': '8997',   // BLUEINFLATiQ  $89.97
    '52078004404533': '17997',  // BLUEINFLATiQ-2  $179.97
    '52078004437301': '26997',  // BLUEINFLATiQ-3  $269.97
    '52078004470069': '35997',  // BLUEINFLATiQ-4  $359.97

    // All-Fit Replacement Body Side Molding – 1992-1996 Ford
    '50853374558517': '14997',  // FORD9296BlackCh26  $149.97
    '50853374591285': '16197',  // FORD9296WHITECH26  $161.97

    // PROTECTiQ PRO 6 Color Sample Pack
    '50820398842165': '39597',  // SAMPLE6PIQP  $395.97

    // BASiQ - Single Pack
    '50853270225205': '4197',   // BASiQBLACK-FBA  $41.97
    '50853270323509': '4197',   // BASiQBLUE-FBA  $41.97
    '50853270257973': '4197',   // BASiQRED-FBA  $41.97
    '50853270290741': '4197',   // BASiQYELLOW-FBA  $41.97
    '50853270356277': '4197',   // BASiQWHITE-FBA  $41.97
    '50853270389045': '4197',   // BASiQSILVER-FBA  $41.97

    // PROTECTiQ - Single Pack
    '50853301944629': '5997',   // STANiQred  $59.97
    '50853301977397': '5997',   // STANiQblack  $59.97
    '50853302010165': '5997',   // STANiQyellow  $59.97
    '50853302042933': '5997',   // STANiQblue  $59.97
    '50853302075701': '5997',   // STANiQwhite  $59.97
    '50853302108469': '5997',   // STANiQsilver  $59.97

    // All-Fit Replacement Body Side Molding - 1987-1991 Ford F150, F250, F350 & Ford Bronco
    '50853416862005': '17397',  // FORD8791CHROME26  $173.97

    // All-Fit UnlimiTrim
    '51005440753973': '2397',   // Unlimi1/4CarbonF  $23.97
    '51005440786741': '2397',   // Unlimi1/4Chrome  $23.97
    '51005440819509': '2397',   // Unlimi1/4Red  $23.97
    '51005440852277': '2397',   // Unlimi1/4White  $23.97
    '51005440885045': '2397',   // Unlimi1/4Black  $23.97
    '51005440917813': '2397',   // Unlimi1/4Yellow  $23.97
    '51005440950581': '2397',   // Unlimi1/4Blue  $23.97
    '51005440983349': '2397',   // Unlimi1/4Orange  $23.97
    '51005441016117': '2397',   // Unlimi1/4Gold  $23.97

    // Apparel Package
    '51028317176117': '2397',   // SMALLTEE  $23.97
    '51028317208885': '2397',   // MEDIUMTEE  $23.97
    '51028317241653': '2397',   // LARGETEE  $23.97
    '51028317274421': '2397',   // XLTEE  $23.97
    '51028317307189': '2397',   // 2XLTEE  $23.97

    // 3M Adhesion Promoter
    '51028321993013': '1197',   // 3m-adhesive-promoter  $11.97

    // Screws and Washers – 14
    '51028330709301': '1197',   // SCREWS-WASHERS-14  $11.97

    // All-Fit Bumper Quick Release Replacement Bands
    '51028334281013': '1197',   // QRRBANDS  $11.97

    // Stickers
    '51028337033525': '777',    // STICKERS-1  $7.77

    // All-Fit Lip Kit - Black
    '51065282494773': '29997',  // TRDLIPKIT-BL30  $299.97
    '51065282527541': '8997',   // TRDLIPKIT-BL09  $89.97
    '51065282560309': '13797',  // TRDLIPKIT-BL14  $137.97
    '51065282593077': '22797',  // 23TLB  $227.97
    '51065283150133': '39597',  // MLB30  $395.97
    '51065283182901': '11997',  // MLB09  $119.97
    '51065283215669': '18597',  // MLB14  $185.97
    '51065283248437': '30597',  // MID23B  $305.97
    '51065283805493': '49797',  // FLB30  $497.97
    '51065283838261': '14997',  // FLB09  $149.97
    '51065283871029': '23097',  // FL14B  $230.97
    '51065283903797': '38097',  // FAT23B  $380.97

    // All-Fit Replacement Body Side Molding – 1988-1999 Chevy/GMC
    '51127935467829': '14997',  // GMC2.5Chrome26  $149.97
    '51127937564981': '14997',  // GMC2.5ALLBLACK26  $149.97

    // All-Fit Replacement Body Side Molding - 1999–2007 Chevy Silverado, Tahoe & CK-Series
    '51143227539765': '19797',  // CHEVY99-07BLCHROME26.3.7/8  $197.97

    // TKTK SPECIAL INFLATiQ® by RIMiQ® Portable Tire Inflator - Powerful, Award-Winning QwikFlow® Technology
    '52897379582261': '7797',   // TKTKiQPump-Teal  $77.97
    '52897379615029': '8997',   // TKTKiQPump-Blue  $89.97
    '52897379647797': '8997',   // TKTKiQPump-Pink  $89.97

    // All-Fit Edge Trim Tiktok
    '52040176795957': '1497',   // EDGET10BLACK-TIKTOK  $14.97
    '52040176828725': '1497',   // EDGET10CHROME-TIKTOK  $14.97
    '52040176894261': '1497',   // EDGET10RED-TIKTOK  $14.97
    '52040224145717': '1497',   // EDGET10PINK-TIKTOK  $14.97
    '52897272660277': '1497',   // EDGET10SILVER-TIKTOK  $14.97
    '52897273086261': '1497',   // EDGET10YELLOW-TIKTOK  $14.97
    '52897273282869': '1497',   // EDGET10ORANGE-TIKTOK  $14.97
    '52897273413941': '1497',   // EDGET10BLUE-TIKTOK  $14.97
    '52897273545013': '1497',   // EDGET10GOLD-TIKTOK  $14.97
    '52897273708853': '1497',   // EDGET10CFIBER-TIKTOK  $14.97
    '52897274200373': '1497',   // EDGET10DARKRED-TIKTOK  $14.97
    '52897274560821': '1497',   // EDGET10CLEAR-TIKTOK  $14.97
    '52897275674933': '1497',   // EDGET10WHITE-TIKTOK  $14.97

    // PROTECTiQ PRO 25 Count Mixed Colors
    '50820367286581': '155997', // RIMIQSEMA25  $1559.97

    // All-Fit Replacement Body Side Molding – 1983–1990 Chevy/GMC/Toyota
    '51127951294773': '14997',  // CHEVY8390BLCHROME26.2.3/8  $149.97

    // All-Fit Flex Trim
    '50816433750325': '2397',   // 1/4FLEXT10CHROME  $23.97
    '50816433881397': '2397',   // 1/4FLEXT10RED  $23.97
    '50816434012469': '2397',   // 1/4FLEXT10DARKRED  $23.97
    '50816434143541': '2397',   // 1/4FLEXT10CFIBER  $23.97
    '50816434274613': '2397',   // 1/4FLEXT10YELLOW  $23.97
    '50816434405685': '2397',   // 1/4FLEXT10ORANGE  $23.97
    '50816434536757': '2397',   // 1/4FLEXT10BLUE  $23.97
    '50816434667829': '2397',   // 1/4FLEXT10WHITE  $23.97
    '50816434798901': '2397',   // 1/4FLEXT10GOLD  $23.97
    '50816433783093': '2997',   // 1/2FLEXT10CHROME  $29.97
    '50816433914165': '2997',   // 1/2FLEXT10RED  $29.97
    '50816434176309': '2997',   // 1/2FLEXT10CFIBER  $29.97
    '50816433815861': '3297',   // 3/4FLEXT10CHROME  $32.97
    '50816433946933': '3297',   // 3/4FLEXT10RED  $32.97
    '50816434078005': '3297',   // 3/4FLEXT10DARKRED  $32.97
    '50816434209077': '3297',   // 3/4FLEXT10CFIBER  $32.97
    '50816433848629': '3597',   // 1FLEXT10CHROME  $35.97
    '50816433979701': '3597',   // 1FLEXT10RED  $35.97
    '50816434110773': '3597',   // 1FLEXT10DARKRED  $35.97
    '50816434241845': '3597',   // 1FLEXT10CFIBER  $35.97

    // Product Sample
    '52065328103733': '1497',   // (no SKU)  $14.97

    // All-Fit Replacement Body Side Molding – 1994–1997 Dodge Ram BR/BE-Series, 1500, 2500, & 3500
    '52087161848117': '17397',  // RAM9497BLCHROME26.1.7/8  $173.97

    // All-Fit Replacement Body Side Molding - 2003-2009 Chevy Silverado & Tahoe
    '52094386340149': '19797',  // CHEVYRD03-09BLCHROME26.4.1/4  $197.97

    // PROTECTiQ PRO - Single Pack - TikTok
    '52339648299317': '7797',   // PROiQBLACK-FBA  $77.97
    '52339648332085': '7797',   // PROiQRED-FBA  $77.97
    '52339648364853': '7797',   // PROiQYELLOW-FBA  $77.97
    '52339648397621': '7797',   // PROiQBLUE-FBA  $77.97
    '52339648430389': '7797',   // PROiQWHITE-FBA  $77.97
    '52339648463157': '7797',   // PROiQSILVER-FBA  $77.97

    // Pink Bundle - 30% Off
    '52873003368757': '2997',   // (no SKU)  $29.97

    // Pink Bundle + INFLATiQ - 50% Off
    '52873166618933': '5997',   // (no SKU)  $59.97

    // Mighty Mini™ by INFLATiQ® Portable Inflator
    '53078059745589': '5997',   // MIGHTYMINIDEAL  $59.97

    // INFLATiQ Replacement Hose
    '52526014398773': '1497',   // AirHose  $14.97
  };

  // ============ NO EDITS NEEDED BELOW THIS LINE ============

  var GALLERY = '.thb-product-detail .product-image-container';
  var PRODUCT_INFO = '.thb-product-detail [id^="ProductInfo-"]';

  if (window.__afaSaleBadge) return;
  window.__afaSaleBadge = true;

  function currentVariantId() {
    // The theme writes ?variant= to the URL when the shopper picks a variant.
    var fromUrl = new URLSearchParams(location.search).get('variant');
    if (fromUrl) return fromUrl;
    // First load with no ?variant=: read the main product form.
    var input = document.querySelector(PRODUCT_INFO + ' form[action*="/cart/add"] [name="id"]') ||
                document.querySelector('.thb-product-detail form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  }

  function update() {
    var host = document.querySelector(GALLERY);
    if (!host) return;

    var img = host.querySelector(':scope > .afa-sale-badge');
    if (!img) {
      img = document.createElement('img');
      img.className = 'afa-sale-badge';
      img.alt = 'Sale';
      img.width = 400;
      img.height = 400;
      img.decoding = 'async';
      img.onerror = function () { this.dataset.failed = '1'; this.hidden = true; }; // file missing: show nothing
      host.appendChild(img);
    }

    var code = BADGES[currentVariantId()];
    if (code) {
      var src = IMAGE_BASE + 'sale-badge-' + code + '.png';
      if (img.getAttribute('src') !== src) {
        img.dataset.failed = '';
        img.setAttribute('src', src);
      }
      img.hidden = img.dataset.failed === '1';
    } else {
      img.hidden = true;
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }

  function init() {
    if (!document.querySelector(GALLERY)) return; // not a product page

    update();

    // Variant changes: inputs fire "change"; the theme then rewrites the URL.
    document.addEventListener('change', function () { schedule(); setTimeout(update, 120); }, true);
    window.addEventListener('popstate', schedule);
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      history[fn] = function () {
        var r = orig.apply(this, arguments);
        schedule();
        return r;
      };
    });

    // If the theme re-renders the gallery, put the badge back.
    var root = document.querySelector('.thb-product-detail');
    if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();